<template>
  <div class="table">
    <a-modal v-model="modalVisible" title="选择审核结果" width="425px" centered>
      <div class="change-examine">
        <a-form-model ref="ruleForm" :model="examineForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
          <a-form-model-item label="选择审核结果" prop="status" style="margin-bottom: 10px;">
            <a-radio-group v-model="examineForm.status" name="status" :default-value="1">
              <a-radio :value="2">同意</a-radio>
              <a-radio :value="3">驳回</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="驳回原因" prop="reason" style="margin-bottom: 10px;" v-if="examineForm.status == '3'" :rules="{ required: true, message: '请输入驳回原因',trigger: 'blur'}">
            <a-input type="textarea" v-model="examineForm.reason" placeholder="请输入驳回原因" style="width: 100%;height:140px;"></a-input>
          </a-form-model-item>
        </a-form-model>
      </div>
      <div slot="footer" class="modal-footer">
        <a-button type="primary" @click="examineConfirm()">提交</a-button>
        <a-button type="primary" class="cancel" @click="modalVisible=false">取消</a-button>
      </div>
    </a-modal>
    <table v-if='hisList.length>0'>
      <thead>
        <td width='160'>时间</td>
        <td width='160'>操作人员</td>
        <td width='200'>操作记录</td>
        <td width='100'>状态</td>
        <td width='80'>操作</td>
      </thead>
      <tbody>
        <tr v-for='(i,index) in hisList' :key='index'>
          <td>{{i.create_time}}</td>
          <td>
            <span v-if='i.manager'>{{i.manager.title}}</span>
            <span v-else>/</span>
          </td>
          <td>
            <Normap :tit='i.content'></Normap>
          </td>
          <td class="status" :class='{"ing":i.status==1,"err":i.status==3,"oky":i.status==2}'>
            <span>{{i.status | rStatus}}</span>
          </td>
          <td v-if='(type==1 && $common.AUTH("1-1-4")) || (type==2 && $common.AUTH("0-6-5"))'>
            <a href='javascript:void(0);' v-if='i.status==1' @click="examineClick(i.id,i.type)">审核</a>
            <span v-else>-</span>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="pages" v-if='total>10'>
      <a-pagination v-model="form.page" :total="total" show-less-items :pageSize='10' @change='turnpage' />
    </div>
    <!-- <a-empty description='暂无数据' v-if="total==0" style="margin:20px 0;" /> -->
  </div>
</template>
<script>
import { loadHis } from '@/server/loan'
import { debtorHis } from '@/server/debtor'
import { auditCheck } from "@/server/audit"
export default {
  name:'HisTable',
  props: {
    type: Number,
    loan_id: Number,
  },
  data() {
    return {
      like: 0, //用来判断是否是结清 然后刷新页面
      modalVisible: false,
      types: null,
      examineForm: {
        id: '',
        status: 2,
        reason: ''
      },
      form: {
        limit: 10,
        page: 1
      },
      total: null,
      hisList: [],
    }
  },
  filters: {
    rStatus(val) {
      let keyjson = { 1: "待审核", 2: "审核通过", 3: "审核拒绝" }
      return keyjson[val]
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      let form = JSON.parse(JSON.stringify(this.form))
      if (this.type == 1) {
        form.loan_id = this.loan_id;
        loadHis(form).then(e => {
          this.total = e.count
          this.hisList = e.list
        })
      } else {
        form.debtor_id = this.$route.params.id;
        debtorHis(form).then(e => {
          this.total = e.count;
          this.hisList = e.list

        })
      }
    },
    examineConfirm() {
      auditCheck(this.examineForm).then((res) => {
        this.$message.success({ content: '审核成功' });
        if (this.type == 22) {
          setTimeout(e => {
            window.history.go(0)
          }, 500)
        } else {
          this.init();
          this.$emit("resh", 1)
          this.modalVisible = false
        }
      })
    },
    turnpage(val) {
      this.form.page = val;
      this.init()
    },
    examineClick(id, type) {
      this.like = type
      this.modalVisible = true
      this.examineForm.id = id
    }
  },
}
</script>
<style lang="less" scoped>
.pages {
  text-align: center;
}
</style>